import Parse from "parse";

type OD3_Tenant = Parse.Object;

export interface Ticket_FormConfigAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  config: any;
  tenant?: OD3_Tenant;
  view: string;
}

export class Ticket_FormConfig extends Parse.Object<Ticket_FormConfigAttributes> {
  static className: string = "OD3_Maintenance_Ticket_FormConfig";

  constructor(data?: Partial<Ticket_FormConfigAttributes>) {
    super("OD3_Maintenance_Ticket_FormConfig", data as Ticket_FormConfigAttributes);
  }

  get config(): any {
    return super.get("config");
  }
  set config(value: any) {
    super.set("config", value);
  }
  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }
  get view(): string {
    return super.get("view");
  }
  set view(value: string) {
    super.set("view", value);
  }
}

Parse.Object.registerSubclass("OD3_Maintenance_Ticket_FormConfig", Ticket_FormConfig);
